<script setup lang="ts">
import AnnouncementsLayout from '@/components/Announcements/AnnouncementLayout.vue'
import { ref } from 'vue'

const announcements = ref([])
const closeAnnouncement = (id: number) => console.log({ id })
</script>

<template>
    <AnnouncementsLayout :announcements="announcements" @close="closeAnnouncement" />
</template>

<style scoped lang="scss">
.announcements-layout {
    overflow-x: auto;
    padding-bottom: 0.5em;
}
</style>
